import { Link } from "react-router-dom";
import Logo from "../ui/Logo";

function Footer() {
  return (
    <footer className="border-t border-cyan-300/10 bg-[#02070d]">
      <div className="shell grid gap-8 py-10 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Link to="/" className="text-left">
            <Logo />
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-6 text-slate-400">
            Elektroinstalace pro domy, byty a firmy v Karlovarskem kraji.
          </p>
        </div>
        <div>
          <h3 className="text-sm font-bold uppercase tracking-wide text-white">Kontakt</h3>
          <p className="mt-3 text-sm leading-7 text-slate-400">
            +420 123 456 789
            <br />
            info@eltt.cz
          </p>
        </div>
        <div>
          <h3 className="text-sm font-bold uppercase tracking-wide text-white">Administrace</h3>
          <Link to="/admin" className="mt-3 inline-flex text-sm font-semibold text-cyan-300 hover:text-cyan-200">
            Prihlaseni spravce
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
